import { colors } from '@packages/design';

import { Assets } from '@assets';
import { Container } from '@components/container';
import { Text } from '@elements/text';
import { useNavigateToFreely } from '@hooks';

const ConfirmationHeader = () => {
  const { openRedirectToFreelyModal } = useNavigateToFreely();

  return (
    <div className="bg-surface-primary">
      <Container>
        <span className="flex items-center  gap-s4 sm:gap-s12 ">
          <Assets.FreelyPrime
            className="w-16 h-8 sm:h-10 sm:w-24 "
            onClick={openRedirectToFreelyModal}
            fill={colors.fuji[800]}
          />
          <div className="h-4 mb-1 flex self-end">
            <Text variant={'footnote-12/r'}>Backed by</Text>
            <Assets.Zurich fill={colors.fuji[800]} className="h-4 w-16 ml-s8" />
          </div>
        </span>
      </Container>
    </div>
  );
};

export default ConfirmationHeader;
